import { useEffect, useRef } from 'react';

// Google AdSense publisher ID
const ADSENSE_CLIENT = 'ca-pub-3438637420878205';

// Ad slot IDs — create ad units at https://adsense.google.com and paste the slot IDs here.
// Until then, a clean placeholder is rendered.
const AD_SLOTS = {
  banner: '',      // e.g. '1234567890'
  rectangle: '',
  leaderboard: '',
  sidebar: '',
  inFeed: '',
};

const AD_SIZES = {
  banner: { width: 728, height: 90, label: 'Banner Ad' },
  rectangle: { width: 300, height: 250, label: 'Rectangle Ad' },
  leaderboard: { width: 970, height: 90, label: 'Leaderboard Ad' },
  sidebar: { width: 300, height: 600, label: 'Sidebar Ad' },
  inFeed: { width: 728, height: 90, label: 'In-Feed Ad' },
};

/**
 * AdBanner — renders a Google AdSense unit if a slot ID is configured for this placement,
 * otherwise shows a subtle "Advertisement" placeholder (keeps layout stable during review).
 */
export const AdBanner = ({ slot = 'banner', className = '' }) => {
  const adRef = useRef(null);
  const slotId = AD_SLOTS[slot];
  const size = AD_SIZES[slot] || AD_SIZES.banner;

  useEffect(() => {
    if (!slotId) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('AdSense push failed:', err);
      }
    }
  }, [slotId]);

  // No ad unit configured for this placement → render nothing at all rather
  // than an empty placeholder box.
  if (!slotId) return null;

  return (
    <div
      className={`ad-container ${className}`}
      style={{ textAlign: 'center', margin: '0 auto', maxWidth: size.width }}
      data-testid={`ad-slot-${slot}`}
    >
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export const SidebarAd = ({ className = '' }) => (
  <div className={`hidden lg:block sticky top-24 ${className}`}>
    <AdBanner slot="sidebar" />
    <p className="text-center text-[10px] text-[#1C1917]/30 mt-2 font-['Outfit']">
      Sponsored
    </p>
  </div>
);

export const InFeedAd = ({ className = '' }) => (
  <div className={`my-8 ${className}`}>
    <AdBanner slot="inFeed" />
  </div>
);
